module.exports = __webpack_public_path__ + "static/media/sign-in-background.66b0ec11.png";